import { useMutation, useQueryClient } from '@tanstack/vue-query'

import { updateAdmin } from '../adminsEndpoints'
import { adminsQueryKeys } from '../adminsQueryKeys'
import type { UpsertAdminPayload } from '../../types/adminTypes'

interface UpdateAdminArgs {
  id: string
  payload: UpsertAdminPayload
}

export function useUpdateAdminMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, payload }: UpdateAdminArgs) => updateAdmin(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminsQueryKeys.lists() })
    },
  })
}
